import {
  GROUPS_DELETE_REQUEST,
  GROUPS_CREATE_FETCH_REQUEST,
  GROUPS_FETCH_REQUEST,
  GROUPS_FETCH_SUCCESS,
  GROUPS_DELETE_FETCH_SUCCESS,
  GET_GROUP_FETCH_SUCCESS,
  GROUP_RENAME_FETCH_SUCCESS,
  GROUPS_CREATE_REQUEST_ERROR,
  SEARCH_GROUP,
} from './actions'

const initialState = {
  lsLoading: false,
  groupsList: [],
  initGroupList: [],
  groupDetails: [],
}

const groupsReducer = (state, action) => {
  switch (action.type) {
    case SEARCH_GROUP:
      let filteredGroupsList = state.initGroupList
      if (action.searchText !== undefined && action.searchText !== '') {
        filteredGroupsList = state.initGroupList.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(action.searchText.toLowerCase()) !==
            -1
          )
        })
      }
      return {
        ...state,
        groupsList: filteredGroupsList,
      }
    case GROUPS_CREATE_REQUEST_ERROR:
      return {
        ...state,
        lsLoading: false,
      }
    case GROUPS_DELETE_REQUEST:
    case GROUPS_CREATE_FETCH_REQUEST:
    case GROUPS_FETCH_REQUEST:
      return {
        ...state,
        lsLoading: true,
      }
    case GROUPS_FETCH_SUCCESS:
      return {
        ...state,
        groupsList: action.data,
        initGroupList: action.data,
        lsLoading: false,
      }
    case GROUPS_DELETE_FETCH_SUCCESS:
      return {
        ...state,
        lsLoading: false,
      }
    case GET_GROUP_FETCH_SUCCESS:
      return {
        ...state,
        groupDetails: action.data,
        lsLoading: false,
      }
    case GROUP_RENAME_FETCH_SUCCESS:
      return {
        ...state,
        lsLoading: false,
        groupDetails: {
          ...state.groupDetails,
          name: action.data.name,
        },
      }
    default:
      return state
  }
}

export default [groupsReducer, initialState]
